import {Dimensions} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled, {css} from 'styled-components/native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

interface Check {
  checked?: boolean;
}

const {width} = Dimensions.get('window');

export const ModalOverlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: ${RFValue(20)}px;
`;

export const ModalContent = styled.View`
  width: ${Math.min(width * 0.9, 420)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(20)}px;
`;

export const ModalTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.bold};
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalTextBold = styled(ModalText)`
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalCheckboxRow = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
  gap: ${RFValue(8)}px;
`;

export const ModalCheckboxText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const TermCheckIcon = styled(FontAwesome)<Check>`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.text};
  ${({checked, theme}) =>
    checked &&
    css`
      color: ${theme.colors.blue};
    `}
`;
